// DEPENDENCIES
import React, { useState, useContext } from "react";

// CSS
import "./RFAUserFormLogDetails.css";

// MSAL
import { useMsal } from "@azure/msal-react";

// API IMPORTS
import { getAPICall } from "../../../../config/apiCalls";

// CONTEXT
import { UserContext } from "../../../../context/UserContext";

// MUI COMPONENTS
import {
	CircularProgress,
	Dialog,
	DialogContent,
	DialogTitle,
	Divider,
	TextField,
	Typography,
} from "@mui/material";

import { useEffect } from "react";
import {
	convertToPST,
	convertToPSTWithSeconds,
} from "../../../../constants/dateTime";
import { toTitleCase } from "../../../../constants/constants";

// MUI ICONS

// CUSTOM COMPONENTS

// CONSTANTS

// OTHER

// REACT COMPONENT
const RFAUserFormLogDetails = (props) => {
	// MSAL
	const { instance, accounts } = useMsal();

	// STATES
	const [isLoading, setIsLoading] = useState(true);

	// submission details
	const [id, setId] = useState(0);
	const [submitClickedTime, setSubmitClickedTime] = useState("");
	const [submittedTime, setSubmittedTime] = useState(0);
	const [submittedByEmployeeName, setSubmittedByEmployeeName] = useState("");
	const [errorMessage, setErrorMessage] = useState("");

	const [userEmailRetrievedTime, setUserEmailRetrievedTime] = useState(0);

	// deal details
	const [hubspotDealID, setHubspotDealID] = useState("");
	const [hubspotDealName, setHubspotDealName] = useState("Loading...");

	// recipient details
	const [recipientLookupMode, setRecipientLookupMode] = useState("");
	const [recipientEmail, setRecipientEmail] = useState("");
	const [recipientFirstName, setRecipientFirstName] = useState("");
	const [recipientLastName, setRecipientLastName] = useState("");
	const [recipientHubSpotID, setRecipientHubSpotID] = useState("");
	const [
		recipientHubspotCreatedFoundTime,
		setRecipientHubspotCreatedFoundTime,
	] = useState(0);

	// scope details
	const [scopeOne, setScopeOne] = useState("");
	const [scopeTwo, setScopeTwo] = useState("");
	const [scopeThree, setScopeThree] = useState("");
	const [scopeFour, setScopeFour] = useState("");
	const [scopeFive, setScopeFive] = useState("");
	const [scopeSix, setScopeSix] = useState("");
	const [scopeSeven, setScopeSeven] = useState("");
	const [scopeEight, setScopeEight] = useState("");
	const [scopeOneCost, setScopeOneCost] = useState("");
	const [scopeTwoCost, setScopeTwoCost] = useState("");
	const [scopeThreeCost, setScopeThreeCost] = useState("");
	const [scopeFourCost, setScopeFourCost] = useState("");
	const [scopeFiveCost, setScopeFiveCost] = useState("");
	const [scopeSixCost, setScopeSixCost] = useState("");
	const [scopeSevenCost, setScopeSevenCost] = useState("");
	const [scopeEightCost, setScopeEightCost] = useState("");

	const [amendmentInformation, setAmendmentInformation] = useState("");
	const [propertyID, setPropertyID] = useState("");
	const [propertyName, setPropertyName] = useState("");
	const [projectID, setProjectID] = useState("");
	const [projectName, setProjectName] = useState("");
	const [phaseID, setPhaseID] = useState("");
	const [phaseName, setPhaseName] = useState("");
	const [amendmentCreatedTime, setAmendmentCreatedTime] = useState(0);

	const [created, setCreated] = useState("");
	const [modified, setModified] = useState("");
	const [modifiedByName, setModifiedByName] = useState("");

	// CONTEXT
	const employeeID = useContext(UserContext);

	// USE EFFECT
	useEffect(() => {
		if (!props.open) return;

		setIsLoading(true);

		const r = props.recordToView ?? {};

		// submission details
		setId(r.id ?? "N/A");
		setSubmitClickedTime(r.submit_clicked_time ?? "N/A");
		setSubmittedTime(r.submitted_time ?? "N/A");
		setSubmittedByEmployeeName(r.submitted_by_employee_name ?? "N/A");
		setErrorMessage(r.error_message ?? "N/A");
		setUserEmailRetrievedTime(r.user_email_retrieved_time ?? "N/A");

		// deal details
		const hubspotDealIdValue = r.hubspot_deal_id ?? "N/A";
		setHubspotDealID(hubspotDealIdValue);
		setHubspotDealName(
			hubspotDealIdValue === "N/A" ? "N/A" : "Loading..."
		);

		// recipient details
		setRecipientLookupMode(r.recipient_lookup_mode ?? "N/A");
		setRecipientEmail(r.recipient_email ?? "N/A");
		setRecipientFirstName(r.recipient_first_name ?? "N/A");
		setRecipientLastName(r.recipient_last_name ?? "N/A");
		setRecipientHubSpotID(r.recipient_hubspot_id ?? "N/A");
		setRecipientHubspotCreatedFoundTime(
			r.recipient_hubspot_created_found_time ?? "N/A"
		);
		// scope details
		setScopeOne(r.scope_one ?? "N/A");
		setScopeTwo(r.scope_two ?? "N/A");
		setScopeThree(r.scope_three ?? "N/A");
		setScopeFour(r.scope_four ?? "N/A");
		setScopeFive(r.scope_five ?? "N/A");
		setScopeSix(r.scope_six ?? "N/A");
		setScopeSeven(r.scope_seven ?? "N/A");
		setScopeEight(r.scope_eight ?? "N/A");
		setScopeOneCost(r.scope_one_cost ?? "N/A");
		setScopeTwoCost(r.scope_two_cost ?? "N/A");
		setScopeThreeCost(r.scope_three_cost ?? "N/A");
		setScopeFourCost(r.scope_four_cost ?? "N/A");
		setScopeFiveCost(r.scope_five_cost ?? "N/A");
		setScopeSixCost(r.scope_six_cost ?? "N/A");
		setScopeSevenCost(r.scope_seven_cost ?? "N/A");
		setScopeEightCost(r.scope_eight_cost ?? "N/A");

		setAmendmentInformation(r.amendment_information ?? "N/A");
		setPropertyID(r.property_id ?? "N/A");
		setPropertyName(r.property_name ?? "N/A");
		setProjectID(r.project_id ?? "N/A");
		setProjectName(r.project_display_name ?? r.project_name ?? "N/A");
		setPhaseID(r.phase_id ?? "N/A");
		setPhaseName(r.phase_name ?? "N/A");
		setAmendmentCreatedTime(r.amendment_created_time ?? "N/A");

		setCreated(r.created ?? "N/A");
		setModified(r.modified ?? "N/A");
		setModifiedByName(r.modified_by_name ?? "N/A");

		setIsLoading(false);

		const fetchDealName = async () => {
			await fetchHubspotDealName(hubspotDealIdValue);
		};

		fetchDealName();
	}, [props.open, props.recordToView]);

	// HELPER FUNCTIONS
	const fetchHubspotDealName = async (dealID) => {
		if (!dealID || dealID === "N/A") {
			setHubspotDealName("N/A");
			return;
		}

		setHubspotDealName("Loading...");
		try {
			const res = await getAPICall(
				instance,
				accounts[0],
				"/api/hubspot/getDealFromDealID",
				{ dealID }
			);
			setHubspotDealName(res.data?.properties?.dealname || "N/A");
		} catch (error) {
			console.error("Error fetching HubSpot deal name:", error);
			setHubspotDealName("N/A");
		}
	};

	const formClosed = () => {
		props.setOpen(false);
	};

	// RENDER
	return (
		<Dialog
			id="rfaUserFormLogDetailsDialog"
			open={props.open}
			fullWidth
			maxWidth="lg"
			onClose={formClosed}
		>
			<DialogTitle id="rfaUserFormLogDetailsDialogTitle">
				RFA Submission Details
			</DialogTitle>
			<DialogContent id="rfaUserFormLogDetailsDialogContent">
				{isLoading && (
					<div className="loadingSpinnerContainer">
						<CircularProgress color="primary" />
					</div>
				)}
				{!isLoading && (
					<>
						{/* Submission Details */}
						<Typography variant="h6" gutterBottom>
							Submission Details
						</Typography>
						<div className="rfaUserFormLogDetailsDialogRow">
							<TextField
								sx={{ flex: 3 }}
								id="submittedByEmployeeName"
								label="Submitted By Employee Name"
								value={submittedByEmployeeName}
								disabled
							/>
							<TextField
								sx={{ flex: 3 }}
								id="submittedTime"
								label="Submitted At"
								value={
									submittedTime == "N/A"
										? submittedTime
										: convertToPSTWithSeconds(submittedTime)
								}
								disabled
							/>
						</div>
						<div className="rfaUserFormLogDetailsDialogRow">
							<TextField
								sx={{ flex: 3 }}
								error={errorMessage !== "N/A"}
								id="errorMessage"
								label="Error Message"
								value={errorMessage}
								multiline
								minRows={2}
								disabled
							/>
						</div>

						<Divider />
						<Typography variant="h6" gutterBottom>
							Deal Details
						</Typography>
						<div className="rfaUserFormLogDetailsDialogRow">
							<TextField
								sx={{ flex: 3 }}
								id="hubspotDealID"
								label="HubSpot Deal ID"
								value={hubspotDealID}
								disabled
							/>
							<TextField
								sx={{ flex: 3 }}
								id="hubspotDealName"
								label="HubSpot Deal Name"
								value={hubspotDealName}
								disabled
							/>
						</div>

						<Divider />
						<Typography variant="h6" gutterBottom>
							Recipient Details
						</Typography>
						<div className="rfaUserFormLogDetailsDialogRow">
							<TextField
								sx={{ flex: 3 }}
								id="recipientFirstName"
								label="Recipient First Name"
								value={recipientFirstName}
								disabled
							/>
							<TextField
								sx={{ flex: 3 }}
								id="recipientLastName"
								label="Recipient Last Name"
								value={recipientLastName}
								disabled
							/>
						</div>
						<div className="rfaUserFormLogDetailsDialogRow">
							<TextField
								sx={{ flex: 3 }}
								id="recipientEmail"
								label="Recipient Email"
								value={recipientEmail}
								disabled
							/>
							<TextField
								sx={{ flex: 3 }}
								id="recipientHubSpotID"
								label="Recipient HubSpot ID"
								value={recipientHubSpotID}
								disabled
							/>
						</div>

						<Divider />
						<Typography variant="h6" gutterBottom>
							Scope Details
						</Typography>
						<div className="rfaUserFormLogDetailsDialogRow">
							<TextField
								sx={{ flex: 3 }}
								id="scopeOne"
								label="Scope One"
								value={scopeOne}
								disabled
							/>
							<TextField
								sx={{ flex: 3 }}
								id="scopeOneCost"
								label="Scope One Cost"
								value={scopeOneCost}
								disabled
							/>
							<TextField
								sx={{ flex: 3 }}
								id="scopeTwo"
								label="Scope Two"
								value={scopeTwo}
								disabled
							/>
							<TextField
								sx={{ flex: 3 }}
								id="scopeTwoCost"
								label="Scope Two Cost"
								value={scopeTwoCost}
								disabled
							/>
						</div>
						<div className="rfaUserFormLogDetailsDialogRow">
							<TextField
								sx={{ flex: 3 }}
								id="scopeThree"
								label="Scope Three"
								value={scopeThree}
								disabled
							/>
							<TextField
								sx={{ flex: 3 }}
								id="scopeThreeCost"
								label="Scope Three Cost"
								value={scopeThreeCost}
								disabled
							/>
							<TextField
								sx={{ flex: 3 }}
								id="scopeFour"
								label="Scope Four"
								value={scopeFour}
								disabled
							/>
							<TextField
								sx={{ flex: 3 }}
								id="scopeFourCost"
								label="Scope Four Cost"
								value={scopeFourCost}
								disabled
							/>
						</div>
						<div className="rfaUserFormLogDetailsDialogRow">
							<TextField
								sx={{ flex: 3 }}
								id="scopeFive"
								label="Scope Five"
								value={scopeFive}
								disabled
							/>
							<TextField
								sx={{ flex: 3 }}
								id="scopeFiveCost"
								label="Scope Five Cost"
								value={scopeFiveCost}
								disabled
							/>
							<TextField
								sx={{ flex: 3 }}
								id="scopeSix"
								label="Scope Six"
								value={scopeSix}
								disabled
							/>
							<TextField
								sx={{ flex: 3 }}
								id="scopeSixCost"
								label="Scope Six Cost"
								value={scopeSixCost}
								disabled
							/>
						</div>
						<div className="rfaUserFormLogDetailsDialogRow">
							<TextField
								sx={{ flex: 3 }}
								id="scopeSeven"
								label="Scope Seven"
								value={scopeSeven}
								disabled
							/>
							<TextField
								sx={{ flex: 3 }}
								id="scopeSevenCost"
								label="Scope Seven Cost"
								value={scopeSevenCost}
								disabled
							/>
							<TextField
								sx={{ flex: 3 }}
								id="scopeEight"
								label="Scope Eight"
								value={scopeEight}
								disabled
							/>
							<TextField
								sx={{ flex: 3 }}
								id="scopeEightCost"
								label="Scope Eight Cost"
								value={scopeEightCost}
								disabled
							/>
						</div>

						<Divider />
						<Typography variant="h6" gutterBottom>
							Amendment Details
						</Typography>
						<div className="rfaUserFormLogDetailsDialogRow">
							<TextField
								sx={{ flex: 3 }}
								id="amendmentInformation"
								label="Amendment Information"
								value={amendmentInformation}
								disabled
								multiline
								minRows={2}
							/>
							<TextField
								sx={{ flex: 3 }}
								id="propertyID"
								label="Property ID"
								value={propertyID}
								disabled
							/>
							<TextField
								sx={{ flex: 3 }}
								id="propertyName"
								label="Property Name"
								value={propertyName}
								disabled
							/>
							<TextField
								sx={{ flex: 3 }}
								id="projectID"
								label="Project ID"
								value={projectID}
								disabled
							/>
						</div>
						<div className="rfaUserFormLogDetailsDialogRow">
							<TextField
								sx={{ flex: 3 }}
								id="projectName"
								label="Project Name"
								value={projectName}
								disabled
							/>
							<TextField
								sx={{ flex: 3 }}
								id="phaseID"
								label="Phase ID"
								value={phaseID}
								disabled
							/>
							<TextField
								sx={{ flex: 3 }}
								id="phaseName"
								label="Phase Name"
								value={phaseName}
								disabled
							/>
						</div>
					</>
				)}
			</DialogContent>
		</Dialog>
	);
};

// EXPORT
export default RFAUserFormLogDetails;
